import { combineReducers } from 'redux'

import {
  Addresses,
  BillingAddresses,
  ShippingAddresses,
  SelectedBillingAddressId,
  SelectedShippingAddressId,
  useShippingForBilling
} from '../Features/Address/addressReducers'

import {
  PhoneNumber,
  PhoneText,
  completeCheckoutButtonText
 } from './uiReducers'

import {
  CartItems 
} from '../Features/Cart/cartReducers'

import {
  PaymentOptions,
  SelectedPaymentOptionId,
  PaymentRecord,
  selectedPaymentLabel
} from '../Features/PaymentMethod/paymentMethodReducers'

import { isPlaceOrderPending } from '../Features/PlaceOrder/placeOrderReducers'

import { messages } from '../Features/UserMessaging/userMessagingReducers'

function OrderNumber(state = 0, action) {
  return state;
}

const entities = combineReducers({
  // Address
  Addresses,
  BillingAddresses,
  SelectedBillingAddressId,
  ShippingAddresses,
  SelectedShippingAddressId,

  // Cart
  CartItems,

  // Payment
  PaymentOptions,
  SelectedPaymentOptionId,
  PaymentRecord
});

const ui = combineReducers({
  // Address
  useShippingForBilling,

  // UserMessaging
  messages,
  
  // PlaceOrder
  isPlaceOrderPending,

  PhoneNumber,
  PhoneText,
  completeCheckoutButtonText
});

function constants(state = {}) {
  return state; // they're constants. duh.
};

export const submitQuoteApp = combineReducers({
  ui,
  entities,
  constants
});
